var map = {
	"./1.jpg": 1936,
	"./2.jpg": 5663,
	"./3.jpg": 3954,
	"./4.jpg": 9185,
	"./b-2-shape-1.png": 1468,
	"./b-2-shape-2.png": 2151,
	"./b-2-shape-3.png": 6366,
	"./b-2-shape-4.png": 929,
	"./b-2-shape-5.png": 2536,
	"./b-2-shape-6.png": 867,
	"./b-3-shape.png": 1723,
	"./banner-bg-shape-3.png": 9595,
	"./banner-bg.jpg": 5967,
	"./banner-bottom-1.png": 1161,
	"./banner-bottom-2.png": 194,
	"./image-1.jpg": 8172,
	"./left-curve-line.png": 4149,
	"./right-curved-bg.png": 6193,
	"./right-white-curve.png": 5197,
	"./slide-2-pattern-1.png": 3452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4237;